export default __webpack_public_path__ + "static/media/background-x-overlay.87161ae3.png";